export const ROUTE_NAMES = {
  DASHBOARD: 'dashboard',
  CONVERSATION: 'conversation',
  CONVERSATIONS: 'conversations',
  CREATE_WORKSPACE: 'create-workspace',
  LOADING: 'loading',
  ONBOARDING: 'onboarding',
  SIGN_IN: 'sign-in',
  SIGN_IN_OAUTH: 'sign-in-oauth',
  EXTENSION_UNINSTALLED: 'extension-uninstalled',
  OAUTH2: {
    AUTHORIZE: 'oauth2-authorize',
    PROVIDER_TOKEN: 'oauth2-provider-token',
  },
  SETTINGS_NEW: {
    INDEX: 'settings-new-index',
    PERSONAL: 'personal-settings',
    WORKSPACE: {
      INDEX: 'workspace-settings-index',
      WORKSPACE: 'workspace-settings',
      FOLDERS: 'workspace-settings-folders',
      TEAM: 'workspace-settings-team',
      BILLINGS: 'workspace-settings-billings',
      INTEGRATIONS: 'workspace-settings-integrations',
      BILLING_PORTAL: 'billing-portal',
    },
  },
  HOME: 'home',
  DASHBOARD_DEFAULT: 'dashboard-default',
} as const;

export const ROUTE_META = {
  SETTINGS: 'settings',
};
